import { Head } from '@inertiajs/react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Users, FileText, Activity, Settings } from 'lucide-react'
import { Link } from '@inertiajs/react'
import Layout from '../../components/Layout'

interface Props {
  current_user: {
    id: number
    email: string
    role: string
  }
}

function Dashboard({ current_user }: Props) {
  return (
    <>
      <Head title="Dashboard - CFS" />
      
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Welcome back!
          </h2>
          <p className="text-gray-600">
            You are logged in as {current_user.role === 'admin' ? 'an Admin' : 'a General User'}
          </p>
        </div>

        {current_user.role === 'admin' && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium text-blue-900">Admin Dashboard</h3>
                <p className="text-blue-700 mt-1">Manage users, countries, providers, clients, and verticals</p>
              </div>
              <Link href="/admin">
                <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                  Go to Admin Dashboard
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

// Set persistent layout
Dashboard.layout = page => <Layout>{page}</Layout>;

export default Dashboard;